import React, { Component, useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import { Route, Link } from "react-router-dom";
import MyModal from "../components/MyModal";
import LinkButton from '../components/LinkButton';
import * as $ from 'jquery'
import * as MySound from '../components/MySound';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../components/GlobalContext';

export const LoadTruck = (props) => {
    const [state, setState] = useState(reset());
    let txtID = null;
    function reset(saveState) {
        let defaultState = { truckID: "", palletID: "", headerTitle: "Scan Truck Manifest ID", sending: false };
        if (saveState) {
            setState(defaultState);
        }else
            return defaultState;
    }
    useEffect(() => {
        txtID.focus();
    });
    function txtKeyPressed(e) {
        if (e?.which == 13) {
            let $target = $(e.currentTarget);
            let value = $target.val();
            var newState = { ...state };
            if (newState.truckID == "") {
                newState.truckID = value;
                newState.headerTitle = "Scan Pallet ID";
                MySound.play(MySound.Sound.next);
            } else {
                newState.palletID = value;
                newState.headerTitle = MyGlobal.strings.sending;
                newState.sending = true;
            }
            $target.val("");
            $target.focus();
            setState(newState);
        }
    }


    async function SendTruckLoad () {
        //   const token = await authService.getAccessToken();
        let userID = MyGlobal.user;
        let url = `api/Tote/ClientMoveTruckLoad?palletID=${state.palletID}&truckID=${state.truckID}&userID=${userID}`;

        const response = await fetch(url, {
        //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (data.length > 0) {
            MySound.play(MySound.Sound.next);
        } else {
            MySound.play(MySound.Sound.stop);
        }
        reset(true);
    }

    if (state.sending)
        SendTruckLoad();

    return (<div className="container">
        <MyHeading>{state.headerTitle}</MyHeading>
        <div className="form-group">
            <div className="input-group">
                <input className="form-control"
                    type="text"
                    onKeyPress={(e) => {
                        txtKeyPressed(e);
                    }}
                    name="txtID"
                    id="txtID"
                    autoFocus
                   ref={(input) => { txtID = input; }}
                    readOnly={state.sending}
                />

            </div>
        </div>
        <div className={state.truckID == "" ? "d-none" : "form-group "}  >
            <div className="form-text" >Scanned Truck Manifest ID</div>
            <label className="form-label">{state.truckID}</label>
        </div>
        <div className={state.palletID == "" ? "d-none" : "form-group "}  >
            <div className="form-text" >Scanned Pallet ID</div>
            <label className="form-label">{state.palletID}</label>
        </div>
        <button className="btn btn-success col-12 mb-2" disabled={state.sending} onClick={() => { reset(true); }}>Refresh</button>
    </div>)


}
